import { Button, Icon, Text, ButtonTypes, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box, Pressable, IPressableProps } from 'native-base';
import React from 'react';

interface FilterButtonProps {
  isDisabled: boolean;
  isMobile: boolean;
  onPress: () => void;
  count: number;
}

interface ClearSelectionButtonProps extends Omit<ButtonTypes.CompositeProps, 'children'> {}

interface OrderButtonProps extends Omit<ButtonTypes.CompositeProps, 'children'> {}

interface BasketButtonProps extends IPressableProps {
  count: number;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  isDisabled,
  onPress,
  count,
  isMobile,
}) => {
  const rightIconButtonFilter =
    count === 0 ? (
      <Icon name="Funnel" size="xxxs" />
    ) : (
      <VStack
        alignItems="center"
        justifyContent="center"
        rounded="full"
        bg="brand.tertiary.light"
        px={Spacing['inline.nano']}
        py={Spacing['inline.quarck']}>
        <Text variant="regular" fontSize={Typography['fontsize.xs']} color={'neutral.white'}>
          {count}
        </Text>
      </VStack>
    );

  return (
    <Button
      variant="secondary"
      isDisabled={isDisabled}
      onPress={onPress}
      {...(!isMobile && { rightIcon: rightIconButtonFilter })}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.darkest">
        Filtrar
      </Text>
    </Button>
  );
};

export const ClearSelectionButton: React.FC<ClearSelectionButtonProps> = ({
  isDisabled,
  ...rest
}) => {
  const buttonClearSelectionColor = isDisabled ? 'neutral.light' : 'feedback.error.default';

  return (
    <Button
      variant="textLink"
      isDisabled={isDisabled}
      p={0}
      rightIcon={<Icon name="Trash" size="xxxs" color={Color[buttonClearSelectionColor]} />}
      {...rest}
      _text={{
        fontFamily: Typography['fontfamily.base.semibold'],
        color: buttonClearSelectionColor,
      }}>
      LIMPAR SELEÇÃO
    </Button>
  );
};

export const OrderButton: React.FC<OrderButtonProps> = ({ isDisabled, ...rest }) => {
  return (
    <Button
      variant="secondary"
      isDisabled={isDisabled}
      {...rest}
      rightIcon={<Icon name="ChevronDown" size="xxxs" />}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.darkest">
        Ordenar
      </Text>
    </Button>
  );
};

export const BasketButton: React.FC<BasketButtonProps> = ({ count, ...rest }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  return (
    <Pressable {...rest}>
      <HStack
        bgColor="background"
        alignItems="center"
        space={Spacing['inline.nano']}
        px={Spacing['inline.xxxs']}
        borderRadius={BoxRadius.sm}
        py={Spacing['inline.nano']}>
        <Icon name="Basket" size="xs" color={Color['brand.tertiary.dark']} />
        <Box
          bg={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 0.5)}
          borderRadius={BoxRadius.sm}
          alignItems="center"
          px={Spacing['inline.nano']}
          py={Spacing['inline.quarck']}>
          <Text color="brand.tertiary.dark" fontSize={Typography['fontsize.md']} variant="semibold">
            {count}
          </Text>
        </Box>
        {!isMobile && (
          <Text color="brand.tertiary.dark" fontSize={Typography['fontsize.md']} variant="semibold">
            Adicionado(s)
          </Text>
        )}
      </HStack>
    </Pressable>
  );
};
